import PropTypes from 'prop-types';
import React from 'react';
import DashboardUnauthorized from './DashboardUnauthorized';

const AccountIncomplete = ({ accountRouteToComplete }) => (
  <DashboardUnauthorized
    headingText='Account Incomplete'
    captionText='Please complete your account to receive more information about offers.'
    buttonLink={accountRouteToComplete}
    buttonText='Complete Account'
  />
);

AccountIncomplete.propTypes = {
  accountRouteToComplete: PropTypes.string.isRequired,
};

export default AccountIncomplete;



// WEBPACK FOOTER //
// ./src/components/Dashboard/AccountIncomplete.js